import { toast } from "react-toastify";

const getElementByXpath = (iframeRef, paths) => {
    if(!iframeRef) {
        return;
    }

    if(Array.isArray(paths)) {
        return paths.reduce(
            (acc, path) => {
                const list = getElementByXpath(iframeRef, path);

                return acc.concat(list);
            },
            []
        );
    }

    const results = [];
    const iframe = iframeRef.current;

    const xPathCleared = paths?.replace("/@href", "");

    try {
        let nodesSnapshot = document.evaluate(
            xPathCleared,
            iframe?.contentDocument,
            null,
            XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
            null
        );

        for (let i=0 ; i < nodesSnapshot.snapshotLength; i++) {
            results.push(nodesSnapshot.snapshotItem(i));
        }

        return results;
    } catch (error) {
        toast.error("There is no such selector.");

        return results;
    }
};

export default getElementByXpath;
